import { type PropsWithChildren, useMemo } from 'react';

import { CardApiContextProvider } from '@/microfrontends/listing/shared/context/CardApiContext';
import { CardContextProvider } from '@/microfrontends/listing/shared/context/CardContext';
import { type TInitCardApiContext } from '@/microfrontends/listing/shared/types/TCardApiContext';
import { type TCardContextData } from '@/microfrontends/listing/shared/types/TCardContextData';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

type CardContextsProps = {
  cardContextData: TCardContextData;
  initCardApi: TInitCardApiContext;
};

export const CardContext = memoWithDisplayName<PropsWithChildren<CardContextsProps>>(props => {
  const { cardContextData, initCardApi, children } = props;

  const contextApi = useMemo(() => initCardApi(cardContextData), [initCardApi, cardContextData]);

  return (
    <CardContextProvider value={cardContextData}>
      <CardApiContextProvider value={contextApi}>{children}</CardApiContextProvider>
    </CardContextProvider>
  );
}, 'CardContexts');
